import './expeCart.css';

export default function ExpeCart({ item }) {
  return (
    <div className="expeCart p-2 w-full h-full bg-primary-700 rounded-sm transform hover:scale-105 transition-all duration-300 cursor-default">
      <p className=" text-secondary-400 leading-4 text-base">
        {item.title} <br />
        <span className="text-primary-300 text-sm ">{item.inst}</span>
      </p>
      <p className="my-2  text-primary-300 leading-4 text-base ">
        To The End <br />
        <span className=" text-sm text-primary-400">
          {item.from}-{item.to}
        </span>
      </p>
      <p className="leading-4 text-sm text-primary-300">{item.comment}</p>
    </div>
  );
}
